export default "__VITE_ASSET__BYamTT9J__"